import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import laptops from "../../Images/laptops.png";

const DiscountSection = ({ images=[], title, color, secondaryColor, link,link2 }) => {
  return (
    <Container>
      <Row className="discount-backcolor my-2  mx-2  d-flex w-100 justify-content-center  align-items-center " style={{ background: `radial-gradient(circle, ${color} 0%, ${secondaryColor} 100%, ${secondaryColor}  100%)` }}>
      
        <Col className="d-flex justify-content-between" >
        <a href={link} target="_blank" rel="noreferrer" style={{ textDecoration: 'none', marginRight:'15px' }}> <img className="dicount-img" src={images[0]} alt="" /></a>
          <div className="discount-title">
          {title}
        </div>
        <a href={link2} target="_blank" rel="noreferrer" style={{ textDecoration: 'none',marginLeft:'15px' }}> <img className="dicount-img" src={images[1]} alt="" /></a>


         
       
      
     
    </Col>
      </Row>
     
    </Container>
  );
};

export default DiscountSection;
